import { AbstractContentState, useCmsContent } from '@cp-shared-15/frontend-integration';
import { ThirdPartyLicenses } from 'cpie-common';
import { fetchThirdPartyLicenses } from './ThirdPartyLicensesSlice';
import { ThirdPartyLicensesContentSelector } from './ThirdPartyLicensesContentSelector';

export function useThirdPartyLicenses(): AbstractContentState<ThirdPartyLicenses> {
    return useCmsContent(fetchThirdPartyLicenses, ThirdPartyLicensesContentSelector);
}
